import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionCoreService from '@/components/pages/CoreServices/SectionCoreService';
import SectionHuman from '@/components/pages/CoreServices/SectionHuman';
import SectionOurClient from '@/components/pages/CoreServices/SectionOurClient';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CoreServices = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Core')}

            <br />
            <span>{t('Services')}</span>
          </h1>
        }
        desc={t(
          ' With an experienced team and a professional workflow, we respond quickly to any feedback or suggestions, ensuring excellent quality in product delivery. This, in turn, improves business results for our clients through the systems we have developed.'
        )}
      />
      <SectionHuman />
      <SectionCoreService />
      <SectionOurClient />
    </div>
  );
};

export default React.memo(CoreServices);
